(function () {
  function setStatus(form, message, tone) {
    var status = form.querySelector("[data-klaviyo-status]");
    if (!status) return;
    status.textContent = message || "";
    status.dataset.tone = tone || "";
  }

  function buildSubscriptionPayload(email, listId) {
    return {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };
  }

  function bindForm(form) {
    if (!form || form.dataset.klaviyoBound === "true") return;
    form.dataset.klaviyoBound = "true";

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var publicKey = form.dataset.klaviyoPublicKey;
      var listId = form.dataset.klaviyoListId;
      var emailInput = form.querySelector('input[type="email"]');
      var submitButton = form.querySelector('button[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : "";

      if (!publicKey || !listId || !email) {
        setStatus(form, form.dataset.errorMessage, "error");
        return;
      }

      if (submitButton) submitButton.disabled = true;
      setStatus(form, form.dataset.loadingMessage, "loading");

      fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(publicKey), {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          "Accept": "application/vnd.api+json",
          "revision": "2026-04-15"
        },
        body: JSON.stringify(buildSubscriptionPayload(email, listId))
      }).then(function (response) {
        if (!response.ok) throw new Error("Klaviyo subscription failed");
        form.reset();
        setStatus(form, form.dataset.successMessage, "success");
      }).catch(function () {
        setStatus(form, form.dataset.errorMessage, "error");
      }).finally(function () {
        if (submitButton) submitButton.disabled = false;
      });
    });
  }

  function init(container) {
    var root = container || document;
    root.querySelectorAll("[data-klaviyo-form]").forEach(bindForm);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
